export const taxModalInitialValue = {
  taxIdOption: '',
  taxId: '',
  stateTaxId: '',
  neighborhood: '',
  sendDealerTaxEmailNotification: false
};

export const DEFAULT_LENGTH_VALUE = 255;
export const MAX_LENGTH_VALUE = 20;

export const INVALID_TAX_FIELD_CHARS_REGEX = /^[^\\<>[\]{}]*$/;
export const INVALID_NUM_TAX_FIELD_CHARS_REGEX = /^[eE+-.]*$/;
export const ONLY_DIGIT_TAX_FIELD_CHARS_REGEX = /[^\d]/g;
export const NAME_ERROR = '\\, <, >, [, ], {, }';
export const PAY_OS_COUNTRIES = ['MXN', 'PER', 'COL', 'ARG', 'CHL'];
export const INVALID_COUNTRY_REGEX = /^[a-zA-Z0-9]*$/;
export const INDIVIDUAL = 'Individual';
